import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import css from './form-helper-text.css';

const FormHelperText = ({ inverse, text }) => (
  <p
    className={classnames(css['ds-form-helper-text'], {
      [css['ds-form-helper-text--inverse']]: inverse,
    })}
  >
    {text}
  </p>
);

FormHelperText.defaultProps = {
  inverse: false,
};

FormHelperText.propTypes = {
  inverse: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default FormHelperText;
